<div class="content">
    <div class="content">
     <div class="container-fluid">
      <div class="row">
       <div class="col-lg-12 col-md-12 col-sm-12 common_title">
       <h2>EDIT - BREEDS MANAGEMENT</h2>
       <p>Edit Breeds record</p>
       <!--<a (click)="backnavigate()" class="back_to"><i class="fa fa-chevron-left" aria-hidden="true"></i>
        Back
       </a>-->
       </div>
      </div>
       <form class="row bottomheight">
                          <!--loader start-->
  <div class="loading-div" *ngIf="isLoading">
    <div class="loading-bar">
        <div class="lds-roller"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        <p class="mt-3">Processing data. Please wait..</p>
    </div>
  </div>
    <!--loader end-->
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group multiple">
          <label for="Farm Name" class="farmmulti">Farm Name</label>
          <select multiple="multiple" name="farmname" id="farmname"  class="form-control" (change)="farmbasedonspecies($event)">
           <ng-container  *ngFor='let getfarms of getfarmlistdata'> 
            <ng-container  *ngFor='let farmload of speciesloadidlooping'> 
        <option *ngIf="(getfarms.tnfr_id==farmload.farmloadid && getfarms.can_delete!='0')" [value]="getfarms.tnfr_id" [class.my_class]="(getfarms.tnfr_id==farmload.farmloadid)" selected >{{getfarms.tnfr_name}}</option>
        <option *ngIf="(getfarms.tnfr_id==farmload.farmloadid && getfarms.can_delete=='0');let else loggedOut" [value]="getfarms.tnfr_id" selected >{{getfarms.tnfr_name}}</option>
        <ng-container *ngIf="resultcond==1">
          <option *ngIf="(getfarms.tnfr_id!=farmload.farmloadid)" [value]="getfarms.tnfr_id">{{getfarms.tnfr_name}}</option>
          </ng-container>
      </ng-container> 
      <ng-container *ngIf="resultcond>1">
        <option  [value]="getfarms.tnfr_id">{{getfarms.tnfr_name}}</option>
        </ng-container>
         </ng-container> 
          </select>
          </div>
          </div>
          <div class="col-lg-4 col-md-6 col-sm-6 dropdowntop">
            <div class="form-group ">
              <label for="Species Name"><span class="dec">Species Name</span></label>
            <select id="speciesid" name="speciesid" title="Select species" data-toggle="dropdown" class="selectpicker form-control myFakeClassselect" (change)="getspeciesvalue($event)">
              <option *ngFor='let specieslist of speciesloaddata'  id="{{specieslist.speciesID}}" value="{{specieslist.id}}">{{specieslist.name}}</option>
            </select>
            </div>
            </div>
        <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="breed Name" >Breed Name</label>
            <input type="text" name="adddose" id="editbreedname" value="" class="form-control">
            </div>
         </div>
        <!--<div class="col-lg-4 col-md-6 col-sm-6">
         <div class="form-group">
         <label for="Breed Name">Breed Name</label>
         <select class="selectpicker form-control">
         <option selected="selected">Breed Name</option>
         <option value="Red Sindhi">Red Sindhi</option>
         <option value="Red Sindhi">Red Sindhi</option>
         </select>
         </div>
         </div>--> 
         <div class="col-lg-4 col-md-6 col-sm-6">
          <div class="form-group">
            <label for="breed Name" >Breed ID</label>
            <input type="text" name="breedid" id="breedid" value="" formControlName="breedid" class="form-control" >
          </div>
         </div>
        <!-- <div class="col-lg-4 col-md-6 col-sm-6">
         <div class="form-group">
         <label for="Breed ID">Family</label>
         <select class="selectpicker form-control">
         <option selected="selected">Bovidae</option>
         <option value="Bovidae">Bovidae</option>
         <option value="Bovidae">Bovidae</option>
         </select>
         </div>
         </div>-->
      
       
       
         <div class="col-lg-4 col-md-6 col-sm-6 dropdowntop">
         <div class="form-group">
          <label for="editstatus" ><span class="dec">Status</span></label>
         <select  id="editstatus" name="breedsEditStatus"  class="selectpicker form-control breedfak" (change)="editstatusvalue()">
         <option value="1">Active</option>
         <option value="0">Inactive</option>
         </select>
         </div>
         </div>
       <div class="col-lg-12 col-md-12 col-sm-12 text-center">
       <a (click)="breedsmanagement()" class="btn btn-fill btn-primary mb-3">Submit<div class="ripple-container"></div></a>
       <button (click)="backnavigate()" class="btn btn-fill btn-default">Cancel<div class="ripple-container"></div></button>
       </div>
       </form>
     </div>
   </div>
 </div>
